/*
===============================================================================================================
                                 Copyright 2024-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

/* eslint-disable no-console */
import apiClient from '@/utilities/api-client';
import { isEmpty } from '@/utilities/validation';
import generatePayload from '@/components/rule-dialog/generate-payload';
import compileChangeObject from './compile-change-object';

export default async ({
  changes: changeArray, merchantId, rootOrgId,
}) => {
  if (isEmpty(changeArray)) return;

  const { ruleBody = {} } = compileChangeObject(changeArray);

  const payload = generatePayload({
    ruleType: ruleBody.ruleType,
    companyId: merchantId,
    name: ruleBody.name,
    conditions: ruleBody.conditions,
    eventData: ruleBody.eventData,
    isDefault: ruleBody.isDefault,
    enabled: ruleBody.enabled,
  });

  try {
    if (ruleBody.ruleId) {
      // update the existing rule
      await apiClient.patch(`${rootOrgId}/company/${merchantId}/rule/${ruleBody.ruleId}`, payload);
    } else {
      // create a rule
      await apiClient.post(`${rootOrgId}/company/${merchantId}/rule`, payload);
    }
  } catch (e) {
    console.log('Could not update or create rule');
    console.log(e);
    throw new Error(e);
  }
};
